import { AuthUserRole } from '@/models/AuthUserModel';

export type Role =
  | 'admin'
  | 'manager'
  | 'frontdesk'
  | 'marketing'
  | 'nurse'
  | 'esthetician'
  | 'owner';

const nonPowRoles: Role[] = ['marketing'];

export const atLeastAdmin = (): Role[] => {
  return ['admin'];
};

export const atLeastManager = (): Role[] => {
  return ['admin', 'manager', 'owner'];
};

export const allStaff = (): Role[] => {
  return ['admin', 'manager', 'frontdesk', 'nurse', 'esthetician', 'owner'];
};

export const managerOrOwner = (): Role[] => {
  return ['manager', 'owner'];
};

export const isAtLeastManager = (roles?: AuthUserRole[]): boolean => {
  if (roles == null) {
    return false;
  }
  for (const r of roles) {
    for (const against of atLeastManager()) {
      if (r.role == against) {
        return true;
      }
    }
  }
  return false;
};

export const isManagerOrOwner = (roles?: AuthUserRole[]): boolean => {
  if (roles == null) {
    return false;
  }
  for (const r of roles) {
    for (const against of managerOrOwner()) {
      if (r.role == against) {
        return true;
      }
    }
  }
  return false;
};

export const isAtLeastAdmin = (roles?: AuthUserRole[]): boolean => {
  if (roles == null) {
    return false;
  }
  for (const r of roles) {
    for (const against of atLeastAdmin()) {
      if (r.role == against) {
        return true;
      }
    }
  }
  return false;
};

export const isNonPowUser = (roles: AuthUserRole[]) => {
  if (roles == null || roles.length == 0) {
    return true;
  }
  for (const r of roles) {
    for (const against of nonPowRoles) {
      if (r.role == against) {
        return true;
      }
    }
  }
  return false;
};
